<template>
    <b-overlay :show="loading" rounded="sm">
        <div class="col">
            <div class="row row-cols-12">
                <div class="col-12 col-xl-2 px-0 mb-3">
                    <div v-if="mode" class="card mb-3 bg-primary text-white noteFinal mr-0 mr-xl-2">
                        <div class="card-body">
                            <button type="button" class="close text-white" v-b-tooltip.hover title="Nota final da sua redação">
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" height="1.25rem">
                                    <path stroke-linecap="round" stroke-linejoin="round" d="M11.25 11.25l.041-.02a.75.75 0 011.063.852l-.708 2.836a.75.75 0 001.063.853l.041-.021M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9-3.75h.008v.008H12V8.25z" />
                                </svg>
                            </button>
                            <div class="h3 fw-bolder w-auto pt-1">
                                {{ noteFinal | number('0.00') }}
                            </div>
                            <div class=" fw-normal my-3 pt-1">
                                Nota Final
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="mode" class="col-12 col-xl-10 px-0 mb-3">
                    <div id="show-notes" class="noteScroll gap-2" @scroll="isVisibleNote(false, 'show-notes')">
                        <div v-if="showArrow" role="button" @click="isVisibleNote(true, 'show-notes')" class="position-absolute mr-2 float p-2 bg-dark text-white rounded-circle top-50 start-100 translate-middle" style="z-index: 10;">
                            <svg class="icon-xl" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" >
                                <path fill-rule="evenodd" d="M16.28 11.47a.75.75 0 010 1.06l-7.5 7.5a.75.75 0 01-1.06-1.06L14.69 12 7.72 5.03a.75.75 0 011.06-1.06l7.5 7.5z" clip-rule="evenodd" />
                              </svg>
                        </div>

                        <b-card :class="mode.fields.length <= 5 ? 'noteCard-5' : 'noteCard'" class="col-12 col-md-3 px-0 mb-3 mb-md-0" v-for="(field) in mode.fields" :key="field.id" :id="field.id+'-note'">
                            <b-form-group class="h-100">
                                <div class="p-2 h3 bg-light text-muted">
                                    {{ form[field.name] }}
                                </div>

                                <div class="desc-text">
                                    <span v-if="field.colors.length > 0" class="mr-2 click" v-b-tooltip.hover title="Cor da marcação referente a essa nota" v-bind:style="{
                                        padding: '5px 6px',
                                        borderRadius: '5px',
                                        background: field.colors[0].color,
                                    }">
                                    &nbsp;&nbsp;&nbsp;
                                    </span>

                                    <span class="fw-normal text-black-50">
                                        {{ field.description }}
                                    </span>
                                </div>
                            </b-form-group>
                        </b-card>
                    </div>
                </div>
            </div>
        </div>
    </b-overlay>
</template>

<script>
export default {
    props: ['essayId'],
    data() {
        return {
            loading: false,
            essay: null,
            mode: null,
            noteFinal: 0,
            form: {},
            showArrow: true,
        }
    },
    created() {

        // Search Note
        this.load()

    },
    watch: {
        mode (){
            if(this.mode.fields.length<=5){
                this.showArrow =false
            }
        }
    },
    methods: {

        short(string, size = 25) {
            if (string.length > size)
                return string.substring(0, size) + '...'

            return string
        },

        isVisibleNote(move = false, elScroll) {
            const el = document.getElementById(String(this.mode.fields[this.mode.fields.length-1].id)+'-note')
            let parentScroller = document.getElementById(elScroll)

            const posicoes = el.getBoundingClientRect();
            const parentPostitions = parentScroller.getBoundingClientRect();

            const inicio = posicoes.left;
            const fim = posicoes.right;

            if(move === true && elScroll){

                parentScroller.scrollTo(fim, 0)

            }

            if((inicio >= 0) && (fim <= parentPostitions.right+10)) {
                    this.showArrow = false;
                    return
            }
            this.showArrow = true;



        },

        load() {
            this.loading = true;
            axios.get('/student/modes/' + this.essayId)
                .then((result) => {
                    const response = result.data.data;

                    // Essay
                    this.essay = response.essay

                    // Mode
                    if (this.essay.theme) {
                        this.mode = this.essay.theme.mode;
                    } else {
                        this.mode = this.essay.mode;
                    }

                    // Mount Form
                    this.mode.fields.forEach((field, fieldKey) => {

                        // Value
                        let valueDefault = null
                        this.essay.results.forEach((note, noteKey) => {
                            if (field.id === note.mode_field_id) {
                                valueDefault = note.value
                            }
                        })

                        // Field
                        this.form[field.name] = valueDefault
                    })

                    // Update
                    this.onChange()

                })
                .finally(() => this.loading = false)
        },

        async onChange() {
            this.noteFinal = await this.calculateFinalNote()
            this.$forceUpdate();
        },

        calculateFinalNote() {

            if (this.mode) {
                let result = 0;
                let calculationString = this.mode.calculation;
                let keysForm = Object.keys(this.form);

                for (let i = 0; i < keysForm.length; i++) {
                    let value = 0;
                    if (this.form[keysForm[i]] !== null)
                        value = this.form[keysForm[i]]

                    calculationString = calculationString.replace(keysForm[i], value)
                }

                // Calculate
                result = eval(calculationString)

                if (result < 0)
                    result = 0

                return result;
            }

            return 0;
        },

    }
}
</script>

<style scoped>
.icon-xl{
    height: 30px;
}
.noteScroll{
    display: block;
    flex-wrap: nowrap;
    overflow-x: scroll;
    scroll-snap-type: x mandatory;
    -webkit-overflow-scrolling: touch;
}

@media (min-width: 768px) {
    .noteScroll{
        display: flex;
        flex-wrap: nowrap;
        overflow-x: scroll;
        scroll-snap-type: x mandatory;
        -webkit-overflow-scrolling: touch;
    }
}

.noteCard-5{
    flex: 1 1 300px;
}
@media (max-width: 1100px) {
    .noteCard-5, .noteCard{
        flex: 0 0 auto;
    }

}
.noteCard{
    flex: 0 0 180px;
}
.desc-text{
    height: 100px;
    overflow-y: auto;
}
.noteFinal{
    height: 100%;
}
</style>
